import React from 'react';
import { MultiValueRemoveProps, components } from 'react-select';
import { SelectOption } from '../MultiFilterDropdown';

function MultiValueRemoveComponent<T>(
  props: MultiValueRemoveProps<SelectOption<T>, true>
) {
  return (
    <div className="removeMultiValue">
      <components.MultiValueRemove {...props} />
    </div>
  );
}

export default MultiValueRemoveComponent;
